export default __webpack_public_path__ + "static/media/noPreviewImage.e9396420.webp";